// ISO 3166-1 alpha-2 codes and English names, for forms and the agreement.
// Types-and-constants only; safe to import from the Worker and both apps.
//
// The list is the shape a <select> wants, so the creator app can map over it
// directly; NAMES is the lookup the agreement renderer needs.

export interface Country {
  code: string;
  name: string;
}

export const COUNTRIES: readonly Country[] = Object.freeze([
  {code: 'AT', name: 'Austria'}, {code: 'AU', name: 'Australia'}, {code: 'BE', name: 'Belgium'},
  {code: 'BG', name: 'Bulgaria'}, {code: 'BR', name: 'Brazil'}, {code: 'CA', name: 'Canada'},
  {code: 'CH', name: 'Switzerland'}, {code: 'CY', name: 'Cyprus'}, {code: 'CZ', name: 'Czechia'},
  {code: 'DE', name: 'Germany'}, {code: 'DK', name: 'Denmark'}, {code: 'EE', name: 'Estonia'},
  {code: 'ES', name: 'Spain'}, {code: 'FI', name: 'Finland'}, {code: 'FR', name: 'France'},
  {code: 'GB', name: 'United Kingdom'}, {code: 'GR', name: 'Greece'}, {code: 'HR', name: 'Croatia'},
  {code: 'HU', name: 'Hungary'}, {code: 'IE', name: 'Ireland'}, {code: 'IL', name: 'Israel'},
  {code: 'IS', name: 'Iceland'}, {code: 'IT', name: 'Italy'}, {code: 'JP', name: 'Japan'},
  {code: 'KR', name: 'South Korea'}, {code: 'LI', name: 'Liechtenstein'}, {code: 'LT', name: 'Lithuania'},
  {code: 'LU', name: 'Luxembourg'}, {code: 'LV', name: 'Latvia'}, {code: 'MT', name: 'Malta'},
  {code: 'MX', name: 'Mexico'}, {code: 'NL', name: 'Netherlands'}, {code: 'NO', name: 'Norway'},
  {code: 'NZ', name: 'New Zealand'}, {code: 'PL', name: 'Poland'}, {code: 'PT', name: 'Portugal'},
  {code: 'RO', name: 'Romania'}, {code: 'RS', name: 'Serbia'}, {code: 'SE', name: 'Sweden'},
  {code: 'SG', name: 'Singapore'}, {code: 'SI', name: 'Slovenia'}, {code: 'SK', name: 'Slovakia'},
  {code: 'TR', name: 'Türkiye'}, {code: 'UA', name: 'Ukraine'}, {code: 'US', name: 'United States'},
  {code: 'ZA', name: 'South Africa'},
]);

export const COUNTRY_CODES: readonly string[] = Object.freeze(COUNTRIES.map((country) => country.code));

const NAMES: Readonly<Record<string, string>> = Object.freeze(
  Object.fromEntries(COUNTRIES.map((country) => [country.code, country.name])),
);

/** The English name for a code, or the code itself when it is not in the list. */
export function countryName(code: string): string {
  const key = String(code || '').trim().toUpperCase();
  if (!key) return '';
  return NAMES[key] ?? key;
}
